// src/components/operationsAssociate/ReceiveItemModal.jsx
import React, { useState, useEffect } from "react"; // MODIFIED: Added useEffect
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://ims.holdthechild.net";

export default function ReceiveItemModal({ closeModal, onReceive, item }) {
    const [quantity, setQuantity] = useState(1);
    const [details, setDetails] = useState("");
    const [vendors, setVendors] = useState([]); // ADDED: State to store vendor list
    const [selectedVendor, setSelectedVendor] = useState(""); // ADDED: State for selected vendor
    const [loading, setLoading] = useState(false);

    // ADDED: Fetch vendors on component mount
    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.get(`${API_URL}/api/vendors`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setVendors(response.data.data);
            } catch (error) {
                console.error("Failed to fetch vendors:", error);
                toast.error("Failed to load vendors. 😥");
            }
        };
        fetchVendors();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const token = localStorage.getItem("token");

        if (quantity <= 0) {
            toast.error("Quantity must be a positive number.");
            setLoading(false);
            return;
        }

        // MODIFIED: Check if a vendor is selected
        if (!selectedVendor) {
            toast.error("Please select a vendor.");
            setLoading(false);
            return;
        }

        const data = {
            itemId: item._id,
            quantity: Number(quantity),
            details: details,
            vendorId: selectedVendor, // ADDED: Pass the selected vendor ID
        };

        try {
            await axios.post(`${API_URL}/api/inventory/receive`, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success(`Successfully added ${quantity} ${item.name} to stock.`);
            onReceive();
            closeModal();
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
            toast.error(`Error: ${errorMessage} 😥`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-xl max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-4">
                    <h2 className="text-2xl font-bold text-green-600">Receive Stock for "{item.name}"</h2>
                    <button type="button" onClick={closeModal} className="text-3xl text-gray-400 hover:text-red-500 font-light">&times;</button>
                </div>

                <div className="space-y-4">
                    <div className="p-4 bg-gray-50 rounded-md">
                        <p className="font-semibold">Current Stock: <span className="text-green-600">{item.inStock} {item.unitOfMeasure}</span></p>
                    </div>

                    <div>
                        <label className="block mb-1 font-medium text-gray-700">Quantity to Receive</label>
                        <input
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            min="1"
                            className="w-full border rounded-md px-3 py-2"
                            required
                        />
                    </div>
                    {/* ADDED: Vendor selection field */}
                    <div>
                        <label className="block mb-1 font-medium text-gray-700">Vendor</label>
                        <select
                            value={selectedVendor}
                            onChange={(e) => setSelectedVendor(e.target.value)}
                            className="w-full border rounded-md px-3 py-2"
                            required
                        >
                            <option value="">Select a Vendor</option>
                            {vendors.map((vendor) => (
                                <option key={vendor._id} value={vendor._id}>
                                    {vendor.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block mb-1 font-medium text-gray-700">Details (e.g., Supplier, Purchase Order #)</label>
                        <textarea
                            value={details}
                            onChange={(e) => setDetails(e.target.value)}
                            rows="3"
                            className="w-full border rounded-md px-3 py-2"
                        ></textarea>
                    </div>
                </div>

                <div className="flex justify-end gap-4 mt-8 pt-4 border-t border-gray-200">
                    <button type="button" onClick={closeModal} className="px-5 py-2 rounded-md border border-gray-300 hover:bg-gray-50" disabled={loading}>Cancel</button>
                    <button type="submit" className="px-5 py-2 rounded-md bg-green-600 text-white hover:bg-green-700 disabled:opacity-50" disabled={loading}>
                        {loading ? "Receiving..." : "Receive Stock"}
                    </button>
                </div>
            </form>
        </div>
    );
}